import { render, staticRenderFns } from "./index.vue?vue&type=template&id=84875f00&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=84875f00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84875f00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/var/www/app/components/FormInput.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,Page: require('/var/www/app/components/Page.vue').default})
